export const SpacePermissionModel = Symbol.for('SpacePermissionModel');
